module.exports = __webpack_public_path__ + "img/26_44.6754caca.png";